import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { captureAttribution } from "@/lib/contact";
import { Nav } from "@/components/launchx/Nav";
import { Hero } from "@/components/launchx/Hero";
import { Marquee } from "@/components/launchx/Marquee";
import { Intro } from "@/components/launchx/Intro";
import { BusinessModels } from "@/components/launchx/BusinessModels";
import { Curriculum } from "@/components/launchx/Curriculum";
import { Tools } from "@/components/launchx/Tools";
import { PracticalTraining } from "@/components/launchx/PracticalTraining";
import { FinalProject } from "@/components/launchx/FinalProject";
import { Personas } from "@/components/launchx/Personas";
import { ProgramDetails } from "@/components/launchx/ProgramDetails";
import { WhyLaunchX } from "@/components/launchx/WhyLaunchX";
import { LeadForm } from "@/components/launchx/LeadForm";
import { FinalCTA } from "@/components/launchx/FinalCTA";
import { FAQ } from "@/components/launchx/FAQ";
import { Footer } from "@/components/launchx/Footer";
import { Floating } from "@/components/launchx/Floating";

export default function HomePage() {
  useEffect(() => {
    captureAttribution();
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-background min-h-screen font-body overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        <BusinessModels />
        <Curriculum />
        <Tools />
        <PracticalTraining />
        <FinalProject />
        <Personas />
        <ProgramDetails />
        <WhyLaunchX />
        <LeadForm />
        <FinalCTA />
        <FAQ />
      </main>
      <Footer />
      <Floating />
      <Toaster position="top-center" richColors />
    </div>
  );
}
